import { IonPage, IonText, useIonRouter } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { motion } from "motion/react";
import { DynamicAvatar } from "@/components/CoreValue/DynamicAvatar";
import { CoreValueRankingRow } from "@/components/CoreValue/RankingRow";
import { Button } from "@/components/Global/Button";
import { Content } from "@/components/Global/Content";
import { queryOptions_coreValuesSelected } from "@/lib/query/functions/core-values/selected";
import { Routes } from "@/lib/router";
import { useSelectorModalStore } from "@/lib/store/modal";

export function ReflectionGenerate() {
	const { t } = useTranslation();
	const router = useIonRouter();
	const present = useSelectorModalStore.use.present();

	const { data: selectedCoreValues } = useQuery({
		...queryOptions_coreValuesSelected(),
	});

	return (
		<IonPage>
			<Content>
				<div className="flex flex-col gap-2 py-4">
					<DynamicAvatar className="pt-6 pb-10" />
					<IonText className="text-brown-600 text-center">
						{t("reflection.generate.description")}
					</IonText>
				</div>
				{!!selectedCoreValues && (
					<div className="flex flex-col gap-2">
						{selectedCoreValues?.map((selectedCoreValue, index) => {
							return (
								<CoreValueRankingRow
									onClick={() => {
										present("coreValuesDetail", {
											item: {
												name: selectedCoreValue.coreValue.name,
												reason: selectedCoreValue.reason,
												score: selectedCoreValue.matchScore,
											},
										});
									}}
									enableAnimation={false}
									key={selectedCoreValue.coreValue.id}
									data={{
										...selectedCoreValue.coreValue,
										number: index + 1,
										matchScore: selectedCoreValue.matchScore,
									}}
								/>
							);
						})}
					</div>
				)}
				{!!selectedCoreValues && (
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ duration: 0.2 }}
					>
						<Button
							className="w-full"
							disabled={selectedCoreValues.length === 0}
							onClick={() => {
								present("coreValuesAccuracyDetailsExplainer", {
									onCompleted: () => {
										router.push(Routes.Dashboard());
									},
								});
							}}
						>
							{t("reflection.generate.finish")}
						</Button>
					</motion.div>
				)}
			</Content>
		</IonPage>
	);
}
